module.exports = __webpack_public_path__ + "img/btnStatus4.9a1bb05f.png";